import * as checkConstant from '@/api/biz/outbound/checkConstant'
import { i18n } from '@/api/i18n'
import * as commonSendPay from '@/api/biz/shipment/pack/commonSendPay'
import * as sparkMD5 from 'spark-md5'
import { qryItemBaseForList } from '@/api/biz/master/masterService'

/**
 * 【1】众、提、柜、空标记
 * @param obCheckM
 * @returns {*}
 */
export const getOrderSign = (obCheckM) => {
  let tab = obCheckM.packageTag;
  let result = getFSign(obCheckM, tab) + getSSign(obCheckM, tab) + getZSign(
    obCheckM, tab);
  return result;
}

/**
 * 大宗订单标记
 * @param obCheckM
 * @returns {*}
 */
export const getBSign = (obCheckM) => {
  if (obCheckM.sendPay.substr(24, 1) == "1") {
    return "大";
  }
  return "";
}

/**
 * 【12】发票标记
 * @param obCheckM
 * @returns {*}
 */
export const getOrderInvoicInfo = (obCheckM) => {
  if (obCheckM.invoiceFlag == checkConstant.YES_CODE) {
    //return "普";
    return i18n.t(checkConstant.general);
  }
  else {
    if (obCheckM.sendPay.substr(36, 1) == "3") {
      //return "电";
      return i18n.t(checkConstant.electric);
    }
    else {
      //return "无";
      return i18n.t(checkConstant.none);
    }
  }
}

/**
 * 【3】显示订单标记：奢（奢侈品）、闪（闪购）、节（节能补贴）、增（赠品订单）
 * @param obCheckM
 * @returns {*}
 */
export const getOrderTag = (obCheckM) => {
  if (obCheckM.resource == checkConstant.YES_CODE) {
    if (obCheckM.sendPay.length >= 148 && obCheckM.sendPay.substr(147, 2) == "02") {
      return "TL"; //TOPLIFE订单 148-149位为02 显示TL
    }
    if (obCheckM.sendPay.substr(37, 1) == "1") {
      //return "礼"; //礼品购订单
      return i18n.t(checkConstant.gift);
    }
    if (obCheckM.sendPay.substr(33, 1) == "5") {
      //return "赠"; //赠品订单
      return i18n.t(checkConstant.present);
    }
    if (obCheckM.sendPay.substr(49, 1) == "1") {
      //return "促"; //促销品订单
      return i18n.t(checkConstant.promotion);
    }
    if (obCheckM.sendPay.substr(19, 1) == "3") {
      //return "高"; //高值品订单
      return i18n.t(checkConstant.height);
    }
    if (obCheckM.sendPay.substr(19, 1) == "2") {
      //return "贵"; //贵品订单
      return i18n.t(checkConstant.expensive);
    }
    if (obCheckM.sendPay.substr(24, 1) == "1") {
      //return "大"; //大宗订单
      return i18n.t(checkConstant.big);
    }
    if (obCheckM.sendPay.substr(19, 1) == "1") {
      //return "奢"; //奢侈品订单
      return i18n.t(
        checkConstant.extravagant);
    }
    if (obCheckM.sendPay.substr(39, 1) == "1") {
      //return "商"; //商采订单
      return i18n.t(checkConstant.business);
    }
  }

  if (commonSendPay.getquickBuyFlag(obCheckM)) {
    //return "闪"; //自营订单 14位为2并且56位为1 显示闪购订单
    return i18n.t(checkConstant.quick);
  }

  return "";
}

/**
 * 【14】无纸化包裹标签时效
 * @param obCheckM
 * @param orderInvoiceInfo
 * @returns {*}
 */
export const getOrderTimeCategory = (obCheckM, orderInvoiceInfo) => {
  let result = '';
  let sendType = '';
  if (obCheckM.resource == checkConstant.YES_CODE) {
    if (commonSendPay.getJZDFlag(obCheckM)) {
      let precisionArrival = "";
      if (orderInvoiceInfo.obShipmentExpend && orderInvoiceInfo.obShipmentExpend.precisionArrival) {
        precisionArrival = orderInvoiceInfo.obShipmentExpend.precisionArrival;
      }
      return precisionArrival;
    }
    if (commonSendPay.getBuyFlag(obCheckM)) {
      return "—";
    }
    sendType = obCheckM.sendPay.substr(0, 1);
  }
  else {
    sendType = obCheckM.sendPay.substr(38, 1);
  }
  let str35 = obCheckM.sendPay.substr(34, 1); //第35位1为上午、2为下午 3为311（夜间配送）
  switch (sendType) {
    case "1":
      result = "211";
      if (str35 == "1") {
        //result = "211 早";
        result = i18n.t(checkConstant.morning211);
      }
      else if (str35 == "2") {
        //result = "211 午";
        result = i18n.t(checkConstant.noon211);
      }
      else if (str35 == "3") {
        result = "311";
      }
      break;
    case "2":
      //result = "次日达";
      result = i18n.t(checkConstant.nextDayArrive);
      break;
    case "3":
      //result = "隔日达";
      result = i18n.t(
        checkConstant.thirdDayArrive);
      break;
    case "4":
      //result = "4日达";
      result = i18n.t(checkConstant.fourthDayArrive);
      break;
    case "5":
      //result = "5日达";
      result = i18n.t(checkConstant.fifthDayArrive);
      break;
    case "6":
      //result = "6日达";
      result = i18n.t(checkConstant.sixthDayArrive);
      break;
    case "7":
      //result = "7日达";
      result = i18n.t(checkConstant.seventhDayArrive);
      break;
    case "8":
      //result = "8+日达";
      result = i18n.t(checkConstant.eighthDayArrive);
      break;
    case "9":
      result = "411";
      break;
  }
  return result;
}

/**
 * 支付方式
 * @param obCheckM
 * @param orderInvoiceInfo
 * @returns {*}
 */
export const getPaymentSign = (obCheckM, orderInvoiceInfo) => {
  let paymentSign = "";
  if (commonSendPay.getTryOut(obCheckM)) {
    //京东试用
    return "京东试用";
  }
  if (isOnlinePayment(obCheckM)) {
    paymentSign = "在线支付";
  }
  else {
    paymentSign = (orderInvoiceInfo.receivableTotalAmount == null ||
      commonSendPay.getBuyFlag(obCheckM)) ? "-" : "¥" + orderInvoiceInfo.receivableTotalAmount + "元";
  }
  return paymentSign;
}

/**
 * 判断是否在线支付
 */
export const isOnlinePayment = (obCheckM) => {
  if (obCheckM.resource == checkConstant.SOURCE_ERP) {
    if (obCheckM.payment == "4") {
      return true;
    }
  }
  else {
    if (obCheckM.sendPay.substr(0, 1) == "0") {
      return true;
    }
  }
  return false;
}

/**
 * 支付方式
 * 泰国新面单用
 * @param obCheckM
 * @param orderInvoiceInfo
 * @returns {*}
 */
export const getPaymentSignTai = (obCheckM, orderInvoiceInfo) => {
  if (obCheckM.payment == "4") {
    return "Online";
  }

  else {
    return "";
  }
}

/**
 * 京准达标识
 * @param obCheckM
 * @returns {*}
 */
export const getJZDSign = (obCheckM) => {
  if (commonSendPay.getJZDFlag(obCheckM)) {
    return "京准达";//京准达
  }
  if (commonSendPay.getTDCJZDFlag(obCheckM)) {
    return "TDC-京准达";
  }
  return "";
}

/**
 * 【15】订单标题
 * 无引用 注释
 * @param obCheckM
 * @returns {string}
 */
// export const getOrderWarehouseText = (obCheckM) => {
//   let result = "";
//   if (commonSendPay.getOutOrder(obCheckM)) {
//     result = result.substr(0, result.lastIndexOf('-') + 1);
//     if (obCheckM.payment == "1") {
//       result += i18n.t(checkConstant.COD);
//     }
//     else {
//       result += i18n.t(checkConstant.ONLINE);
//     }
//   }
//   if (commonSendPay.getquickBuyFlag(obCheckM)) {
//     result += "-" + i18n.t(
//       checkConstant.flashSales);
//   }

//   return result;
// }

/**
 * 【16】客户信息地址
 * @param obCheckM
 * @param tab
 * @returns {*}
 */
export const getOrderCustomerAddress = (obCheckM, tab) => {
  let result = obCheckM.sendAddress;
  if (tab != null) {
    let strZiTiText = getSSign(obCheckM, tab);
    if ((strZiTiText == i18n.t(checkConstant.cabinet) ||
        strZiTiText == i18n.t(checkConstant.carry) ||
        strZiTiText == i18n.t(checkConstant.store)) && tab.PrintAddress) {
      result = tab.PrintAddress;
    }
  }
  if (obCheckM.resource == checkConstant.YES_CODE) {
    if (commonSendPay.getBuyFlag(obCheckM)) {
      result = i18n.t('specialBusinessNormalSend');
    }
  }
  //加邮政编码
  if (obCheckM.ZipCode) {
    result = "【" + obCheckM.ZipCode + "】" + result;
  }
  return result;
}

/**
 * 【17】应收金额
 * @param systemId
 * @param obCheckM
 * @param tab
 * @param orderInvoiceInfo
 * @returns {*}
 */
export const getOrderCustomerAmount = (systemId, obCheckM, tab,
  orderInvoiceInfo) => {
  if (commonSendPay.getTryOut(obCheckM)) {
    //京东试用
    //return "京东试用";
    return i18n.t(checkConstant.JDTrial);
  }
  else if (commonSendPay.getBuyFlag(obCheckM)) {
    return "-";
  }
  else {
    //cod 应收金额=总金额 在线支付应收金额=0 update by gongbinglai 2018.04.20
    if (systemId != null && systemId == checkConstant.SYSTEMID_COMMON) {
      if (obCheckM.payment == "1") {
        return orderInvoiceInfo.ReceivableTzTotalAmount + " " + orderInvoiceInfo.currency;
      }
      else {
        return "0 " + orderInvoiceInfo.currency;
      }
    }
    else {
      if (obCheckM.payment == "1") {
        return orderInvoiceInfo.receivableTotalAmount + " " + orderInvoiceInfo.currency;
      }
      else {
        return "0 " + orderInvoiceInfo.currency;
      }
    }
    //yrp modify end
  }
}

/**
 * 【19】包裹底部条形码
 * @param obCheckM
 * @returns {*}
 */
export const getOrderBarCode = (obCheckM) => {
  if (commonSendPay.getOutOrder(obCheckM)) {
    //海王星标签
    return obCheckM.shipNo;
  }
  else if (commonSendPay.getBuyFlag(obCheckM)) {
    return "";
  }
  else if (obCheckM.resource == 6) {
    return obCheckM.shipNo;
  } else {
    return obCheckM.outboundNo;
  }
}

/**
 * 【20】无纸化包裹标签备注
 * @param obCheckM
 * @param orderInvoiceInfo
 * @returns {*}
 */
export const getOrderRemark = (obCheckM, orderInvoiceInfo) => {
  let result = !orderInvoiceInfo.remark ? "" : orderInvoiceInfo.remark;  //备注

  let strExamine = '';
  let strAcceptance = '';
  let strSaveing = '';
  let strGift = '';
  let strHL = '';
  if (obCheckM.resource == checkConstant.SOURCE_ERP) {
    // 买卖宝订单不显示备注
    if (commonSendPay.getBuyFlag(obCheckM)) {
      result = "—";
      return result;
    }

    strSaveing = obCheckM.sendPay.substr(91, 1);    //节能补贴:1
    strGift = obCheckM.sendPay.substr(33, 1);       //赠订单:5
    strHL = obCheckM.sendPay.substr(96, 1);         //税仓红检、绿检标记:97位（3：红检、4绿检）
    if (strSaveing == "1") {
      if (!result && strGift != "5") {
        //result = "节能补贴";
        result = i18n.t(checkConstant.energySaving);
      }
    }
    else {
      let freshRemark = getSXRemark(obCheckM.sendPay, obCheckM.siteNo);
      if (freshRemark) {
        result += freshRemark;
      }
    }

    if (strHL == "3") {
      //result += " 红通抽检";
      result += " " + i18n.t(checkConstant.redPassCheck2);
    }
    else if (strHL == "4") {
      //result += " 绿通抽检";
      result += " " + i18n.t(checkConstant.greenPassCheck2);
    }

    // 城配订单备注中显示派车单号 - 装车顺序
    if (commonSendPay.getCitySendFlag(obCheckM)) {
      result += " " + obCheckM.scheduleBillCode + "-" + obCheckM.allocateSequence;
    }
  }
  else {
    result = obCheckM.channelsOutboundNo + "\r\n" + obCheckM.outboundNo;
  }

  return result;
}

export const getNewOrderRemark = (obCheckM) => {
  // 订单备注最多展示40个字符,超出的用...代替
  if (obCheckM.orderRemark && obCheckM.orderRemark.length > 40) {
    return '【' + obCheckM.channelsOutboundNo + '】' + obCheckM.orderRemark.substring(0,40) + '...'
  }
  return '【' + obCheckM.channelsOutboundNo + '】' + (obCheckM.orderRemark ? obCheckM.orderRemark : '');
}

export const getKKOrderRemark = (obCheckM) => {
  // 订单备注最多展示40个字符,超出的用...代替
  if (obCheckM.orderRemark && obCheckM.orderRemark.length > 40) {
    return obCheckM.orderRemark.substring(0, 40) + '...'
  }
  return obCheckM.orderRemark ? obCheckM.orderRemark : ''
}

/**
 * 【21】设置二维码的数据
 * @param pkLabel
 * @returns {string}
 */
export const getOrderPackageData = (pkLabel) => {
  let strWeight = '';
  if (pkLabel.packageWeight == null) {
    strWeight = "00.00";
  }
  else {
    strWeight = Number.parseFloat(pkLabel.packageWeight).toFixed(2);
    let start = strWeight.substr(0, strWeight.indexOf('.'));
    let end = strWeight.substr(strWeight.indexOf('.') + 1);
    if (start.length >= 3) {
      //如果整数位大于3或等于3位，包裹重量设为00.00
      start = end = "00";
    }
    strWeight = start + "." + end;
  }
  return pkLabel.packageNo + "@" + strWeight + "@";
}

/**
 * 【22】包裹声明
 * @param obCheckM
 * @returns {*}
 */
export const getOrderComment = (obCheckM) => {
  if (obCheckM.resource == checkConstant.YES_CODE) {
    if (commonSendPay.getOutOrder(obCheckM)) {
      //return @"保留此包裹联时，代表您已经签收并确认配送商品信息。 0J0D" + obCheckM.outboundNo;
      return i18n.t(checkConstant.keepThePackageUniteSignInConfirm) + obCheckM.outboundNo;
    }
    else {
      //return "保留此包裹联时，代表您已经签收并确认配送商品信息。客服须知及退货流程请登录 http://help.jd.com";
      return i18n.t(checkConstant.keepThePackageUniteSignInConfirmCustomerService);
    }
  }
  else {
    //return "保留此包裹联时，代表您已经签收并确认配送商品信息。本运单由京东提供物流服务，商品物权归商家所有，并由商家提供售后服务";
    return i18n.t(checkConstant.keepThePackageUniteSignInConfirmStatement);
  }
}

/**
 * 【泰国】包裹声明
 * @param obCheckM
 * @param orderInvoiceInfo
 * @returns {*}
 */
export const getOrderCommentNew = (obCheckM, orderInvoiceInfo) => {
  if (obCheckM.resource == checkConstant.YES_CODE ||
    checkConstant.YES_CODE == orderInvoiceInfo.eclpRealSource) {
    return i18n.t(
      checkConstant.keepThePackageUniteSignInConfirmCustomerService);
  }
  else {
    return orderInvoiceInfo.sellerMemo;
  }
}

/**
 * (2)Sendpay第二位=3、4、5、6、7、8、9，分别为直采、鲜品、鲜活、控温、冷藏、冷冻、深冷，打印中文汉字(【直采】、【鲜品】、【鲜活】、【控温】、【冷藏】、【冷冻】、【深冷】)。
 * (3)如果ofc下发到wms时，站点id小于等于0的话，打印“生鲜超区”字样。否则为空
 * @param sendPay
 * @param siteNo
 * @returns {string}
 */
export const getSXRemark = (sendPay, siteNo) => {
  let remark = "";
  try {
    let fresh = sendPay.substr(1, 1);
    switch (fresh) {
      case "3":
        remark = "【直采】";
        break;
      case "4":
        remark = "【鲜品】";
        break;
      case "5":
        remark = "【鲜活】";
        break;
      case "6":
        remark = "【控温】";
        break;
      case "7":
        remark = "【冷藏】";
        break;
      case "8":
        remark = "【冷冻】";
        break;
      case "9":
        remark = "【深冷】";
        break;
      default:
        remark = "";
        break;
    }

    if (siteNo && remark) {
      let siteNoInt = Number.parseInt(siteNo);
      if (siteNoInt <= 0) {
        remark += " 生鲜超区";
      }

    }
  }
  catch (error) {
    $notify.error("冷链备注获取异常" + error);
  }
  return remark;
}

/**
 * 获取空半催标记
 * @param obCheckM
 * @param tab
 * @returns {string}
 */
export const getFSign = (obCheckM, tab) => {
  if (obCheckM.resource == checkConstant.YES_CODE) {
    if (getAirTransFlag(obCheckM)) {
      //return "航";
      return i18n.t(checkConstant.air);
    }
    let strTag = obCheckM.sendPay.substr(111, 1);//sendpay第112位！=0时，为半收订单，打印“半”字
    if (strTag != "0") {
      //return "半";
      return i18n.t(checkConstant.self);
    }
  }
  if (obCheckM.resource != checkConstant.YES_CODE) {
    if (getECLPAirTransFlag(obCheckM)) {
      //return "航";
      return i18n.t(checkConstant.air);
    }
  }
  if (obCheckM.reminderStatus == checkConstant.YES_CODE) {
    //return "催";
    return i18n.t(checkConstant.urge);
  }
  return "";
}

/**
 * 自营航运标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getAirTransFlag = (obCheckM) => {
  return obCheckM.sendPay.substr(136, 1) == "1";
}

/**
 * ECLP航运标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getECLPAirTransFlag = (obCheckM) => {
  return obCheckM.sendPay.substr(46, 1) == "1";
}

/**
 * 获取柜店提标记
 * @param obCheckM
 * @param tab
 * @returns {*}
 */
export const getSSign = (obCheckM, tab) => {
  if (obCheckM.resource == checkConstant.YES_CODE) {
    if (commonSendPay.getGSCombinePackageFlag(obCheckM)) {
      //return "合";
      return i18n.t(checkConstant.combine);
    }
    if (commonSendPay.getCitySendFlag(obCheckM)) {
      //return obCheckM.sendPay.substr(123, 1) == "3" ? "集" : "城";
      return obCheckM.sendPay.substr(123, 1) == "3"
        ? i18n.t(checkConstant.collection)
        : i18n.t(checkConstant.city);
    }
    let strZiTiDian = obCheckM.sendPay.substr(21, 1);   //自提标记(第22为不为5)
    if (tab && tab.isZiTi == checkConstant.YES_CODE && strZiTiDian != "7") {
      //return "柜";
      return i18n.t(checkConstant.cabinet);
    }
    else if (tab && tab.isZiTi == checkConstant.YES_CODE && strZiTiDian == "7") {
      //return "店";
      return i18n.t(checkConstant.store);
    }

    if (obCheckM.idShipmentType && obCheckM.idShipmentType == "64" &&
      strZiTiDian != "5" && strZiTiDian != "6" && strZiTiDian != "7") {
      //自提点订单：order.IdShipmentType == "64" && sendpay的第22!=5为自提点定单
      //return "提";
      return i18n.t(checkConstant.carry);
    }
  }
  return "";
}

/**
 * 1号店标识
 * @param obCheckM
 * @returns {*}
 */
export const getWaybillSign = (obCheckM) => {
  if (commonSendPay.getYihaodianSign(obCheckM)) {
    return "1号店";//1号店
  }
  return "";
}

/**
 * 获取安、众标记
 * @param obCheckM
 * @param tab
 * @returns {string}
 */
export const getZSign = (obCheckM, tab) => {
  let sendPay = obCheckM.sendPay;

  // 安心达标记判断
  let strAnXinDa = '';   //安心达标记
  if (obCheckM.resource == checkConstant.YES_CODE && sendPay.length >= 135) {
    strAnXinDa = sendPay.substr(134, 1);   //安心达标记:1
    if (strAnXinDa == "1") {
      //return "安";
      return i18n.t(checkConstant.safety);
    }
  }

  // 众包标记判断
  let strZhongBao = '';   //众包标记
  if (obCheckM.resource == checkConstant.YES_CODE && sendPay.length >= 85) {
    strZhongBao = sendPay.substr(84, 1);   //众包标记:1
    if (strZhongBao == "1") {
      //return "众";
      return i18n.t(checkConstant.crowd);
    }
  }
  return "";
}

/**
 * 开放平台验货、验收标记标记
 * 无调用 且 checkConstant.examine checkConstant.sign无实际导出内容 注释掉
 * @param obCheckM
 * @returns {string}
 */
// export const getExamine = (obCheckM) => {
//   if (obCheckM.resource == checkConstant.YES_CODE) {
//     return "";
//   }
//   let result = '';
//   //开放平台，请开箱验货标记13位：1
//   if (obCheckM.sendPay.substr(12, 1) == "1") {
//     result += i18n.t(checkConstant.examine);
//   }
//   //开放平台，请本人验收标记14位：1
//   if (obCheckM.sendPay.substr(13, 1) == "1") {
//     result += i18n.t(checkConstant.sign);
//   }
//   return result;
// }

/**
 * 三方合作代收点 用“*”代替，比如139****4321，固定电话隐藏010****5856；客户手机号码从第四位开始，中间4位用*号代替， 如15801578126 显示为 158****8126 。
 * @param obCheckM
 * @param oldTel
 * @param strZiTiText
 * @returns {*}
 */
export const getCooperativePointTel = (obCheckM, oldTel, strZiTiText) => {
  if (strZiTiText == i18n.t(checkConstant.store)) {
    let telS =_.replace(oldTel, " ", "").split(';');
    let newTels = "";
    for(let tel of telS){
      let cs = tel;
      if (cs.length < 7) {
        newTels += tel + "; ";
      }
      else {
        let newTel = cs.substr(0,3) + '****'  + cs.substr(cs.length - 4,4);
        newTels += newTel + "; ";
      }
    }
    return newTels.substr(0, newTels.length - 1);
  }
  else if (obCheckM.isHidePhone == 1) {
    let telS = _.replace(oldTel, " ", "").split(';');
    let newTels = "";
    for (let tel of telS) {
      if (tel.length < 7) {
        newTels += tel + "; ";
      }
      else {
        newTels += tel.substr(0, 3) + "^_^" + tel.substr(tel.length - 4, 4) + ";";
      }
    }
    return newTels.substr(0, newTels.length - 1);
  }
  else {
    return oldTel;
  }
}

/**
 * 会员标识
 * 企业级用户 -101打印：企
 * PLUS会员  101、201打印：V
 * 金牌会员 62 打印：V
 * 钻石会员 105 打印：V
 * VIP用户 110 打印：V
 * 其余 不打印
 * @param obCheckM
 * @returns {*}
 */
export const getUserLevel = (obCheckM) => {
  if (obCheckM == null || obCheckM.giftFlag == null) {
    return "";
  }
  if(checkConstant.CORPORATE.indexOf(obCheckM.giftFlag) !=-1){
    return i18n.t(checkConstant.enterprise);
  }
  if(checkConstant.USERLEVELID.indexOf(obCheckM.giftFlag) !=-1){
    return "V";
  }
  return "";
}

/**
 * 获取路区号/卡位号(城配)
 * @param obCheckM
 * @param orderInvoiceInfo
 * @returns {*}
 */
export const getRoadCode = (obCheckM, orderInvoiceInfo) => {
  if (commonSendPay.getCitySendFlag(obCheckM)) {
    return obCheckM.truckSpot;  //城配订单返回卡位号
  }
  let road = "-";
  if (orderInvoiceInfo.obShipmentExpend != null && orderInvoiceInfo.obShipmentExpend.road) {
    road = orderInvoiceInfo.obShipmentExpend.road;
  }
  return (commonSendPay.getBuyFlag(obCheckM)) ? "—" : road;
}

/**
 * 如果stationType在列表中，则不屏蔽包裹标签中的客户信息，如果stationType不在列表中，则按照以下逻辑屏蔽掉客户信息中的姓名和电话号码：
 * @param stationType
 * @returns {boolean}
 */
export const isContainStationType = (stationType) => {
  if (stationType) {
    return false;
  }
  let stationTypeArr = [
    "16",
    "18",
    "20",
    "22",
    "24",
    "26",
    "30",
    "36",
    "38",
    "40",
    "44",
    "52",
    "90",
    "102",
    "128",
    "168"
  ];
  if (!stationTypeArr.contains(stationType)) {
    return true;
  }
  else {
    return false;
  }
}

/**
 * 客户姓名只保留姓
 * @param userName
 * @param obCheckM
 * @returns {*}
 */
export const getUserName = (userName, obCheckM) => {
  let result = userName;
  if (obCheckM.isHideName === 1) {
    if (userName) {
      result = result.substr(0, 1) + "^_^";
    }
  }
  return result;
}

/**
 * 设置国家和站点标记
 */
export const setCountryAndSiteFlag = (model, obCheckM) => {
  if (obCheckM.distributeNo === '1101' || obCheckM.distributeNo === '1102' || obCheckM.distributeNo === '1103') {
    // 美国
    model.countryFlag = 'US';
    model.siteFlag = '3';
  } else if (obCheckM.distributeNo === '6001' || obCheckM.distributeNo === '6002' || obCheckM.distributeNo === '6005') {
    // 马来
    model.countryFlag = 'MY';
    model.siteFlag = '2';
  } else if (obCheckM.distributeNo === '8401' || obCheckM.distributeNo === '8401') {
    // 越南
    model.countryFlag = 'VN';
    model.siteFlag = '5';
  } else if (obCheckM.distributeNo === '4801'){
    // 欧洲
    model.countryFlag = 'EU';
    model.siteFlag = '6';
  } else {
    // 其他
    model.countryFlag = 'OT';
    model.siteFlag = '-1';
  }
  return model;
}

/**
 * 获取认证码
 */
export const getAuthorizationCode = (orderId) => {
  let key = '5626836D3DE7EA33';
  return sparkMD5.hash(orderId + key);
}
